import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, vShow as _vShow, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bee5d628"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auto-system-classification" }
const _hoisted_2 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_4 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode("Order Data Table "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Select order data table", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode("SKU Data Table "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Select SKU data table", -1))
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Analysis Start Date", -1))
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Analysis End Date", -1))
const _hoisted_24 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_25 = { class: "text-danger" }
const _hoisted_26 = { class: "advanced-wrapper mt-3" }
const _hoisted_27 = ["aria-expanded"]
const _hoisted_28 = { class: "advanced-content mt-3" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-12" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Filters", -1))
const _hoisted_32 = {
  key: 0,
  class: "text-muted small mb-2"
}
const _hoisted_33 = { class: "col-md-5" }
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = { class: "col-md-5" }
const _hoisted_36 = ["onUpdate:modelValue"]
const _hoisted_37 = { class: "col-md-2 d-flex" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 0,
  class: "col-12"
}
const _hoisted_40 = { class: "text-danger" }
const _hoisted_41 = { class: "col-md-6 mt-4 mt-md-5" }
const _hoisted_42 = { class: "form-check form-switch" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "ensure-indices"
}, "Ensure indices before running (recommended)", -1))
const _hoisted_44 = { class: "col-md-6 mt-4 mt-md-5" }
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Working Table Override", -1))
const _hoisted_47 = { class: "col-12 mt-4" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Outbound Order Containers", -1))
const _hoisted_49 = {
  key: 0,
  class: "text-muted small mb-2"
}
const _hoisted_50 = { class: "col-xl-3 col-md-6" }
const _hoisted_51 = ["onUpdate:modelValue"]
const _hoisted_52 = { class: "col-xl-3 col-md-6" }
const _hoisted_53 = ["onUpdate:modelValue"]
const _hoisted_54 = { class: "col-xl-3 col-md-6" }
const _hoisted_55 = ["onUpdate:modelValue"]
const _hoisted_56 = { class: "col-xl-3 col-md-6" }
const _hoisted_57 = { class: "d-flex gap-2" }
const _hoisted_58 = ["onUpdate:modelValue"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = {
  key: 0,
  class: "col-12"
}
const _hoisted_61 = { class: "text-danger" }
const _hoisted_62 = { class: "d-flex flex-wrap gap-3 mt-4" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { key: 0 }
const _hoisted_65 = {
  key: 1,
  class: "d-inline-flex align-items-center gap-2"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_67 = ["disabled"]
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "col-lg-6" }
const _hoisted_70 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white p-3" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-0" }, "Request JSON Preview")
], -1))
const _hoisted_72 = { class: "card-body p-3" }
const _hoisted_73 = { class: "preview-block" }
const _hoisted_74 = { class: "col-lg-6" }
const _hoisted_75 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white p-3" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-0" }, "Containers JSON Preview")
], -1))
const _hoisted_77 = { class: "card-body p-3" }
const _hoisted_78 = { class: "preview-block" }
const _hoisted_79 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white p-3" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-0" }, "Classification Results")
], -1))
const _hoisted_81 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_82 = { class: "row mb-3" }
const _hoisted_83 = { class: "col-md-4" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Working Table:", -1))
const _hoisted_85 = { class: "col-md-4" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Window:", -1))
const _hoisted_87 = { class: "col-md-4" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Status:", -1))
const _hoisted_89 = { class: "row mb-3" }
const _hoisted_90 = { class: "col-md-4" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Total Lines", -1))
const _hoisted_92 = { class: "col-md-4" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Total Volume (m�)", -1))
const _hoisted_94 = { class: "col-md-4" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Unique SKUs", -1))
const _hoisted_96 = { class: "row" }
const _hoisted_97 = { class: "col-md-4" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "By Category", -1))
const _hoisted_99 = { class: "preview-block" }
const _hoisted_100 = { class: "col-md-4" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Per-SKU Tote Ranking", -1))
const _hoisted_102 = { class: "preview-block" }
const _hoisted_103 = { class: "col-md-4" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Per-SKU Daily Buckets", -1))
const _hoisted_105 = { class: "preview-block" }
const _hoisted_106 = { class: "mt-3" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Materialised Tables", -1))
const _hoisted_108 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_109 = {
  key: 1,
  class: "text-muted small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.apiError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.apiError), 1))
          : _createCommentVNode("", true),
        _createElementVNode("form", {
          onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
          novalidate: ""
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control shadow-none rounded-0 text-black mb-2",
                  placeholder: "Search order tables",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orderTableSearch) = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.orderTableSearch,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _withDirectives(_createElementVNode("select", {
                  class: "form-control shadow-none rounded-0 text-black",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.orderDataTableName) = $event)),
                  onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.markTouched('orderDataTableName')))
                }, [
                  _hoisted_9,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOrderTables, (table) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: table.tableID,
                      value: table.tableID
                    }, _toDisplayString(table.name || table.tableID), 9, _hoisted_10))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.form.orderDataTableName]
                ]),
                (_ctx.showErrors && _ctx.errors.orderDataTableName)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(_ctx.errors.orderDataTableName), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control shadow-none rounded-0 text-black mb-2",
                  placeholder: "Search SKU tables",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.skuTableSearch) = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.skuTableSearch,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _withDirectives(_createElementVNode("select", {
                  class: "form-control shadow-none rounded-0 text-black",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.skuDataTableName) = $event)),
                  onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.markTouched('skuDataTableName')))
                }, [
                  _hoisted_15,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSkuTables, (table) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: table.tableID,
                      value: table.tableID
                    }, _toDisplayString(table.name || table.tableID), 9, _hoisted_16))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.form.skuDataTableName]
                ]),
                (_ctx.showErrors && _ctx.errors.skuDataTableName)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_17, _toDisplayString(_ctx.errors.skuDataTableName), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _withDirectives(_createElementVNode("input", {
                  type: "datetime-local",
                  class: "form-control shadow-none rounded-0 text-black",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.analysisStartDate) = $event)),
                  onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.markTouched('analysisStartDate')))
                }, null, 544), [
                  [_vModelText, _ctx.form.analysisStartDate]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _withDirectives(_createElementVNode("input", {
                  type: "datetime-local",
                  class: "form-control shadow-none rounded-0 text-black",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.analysisEndDate) = $event)),
                  onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.markTouched('analysisEndDate')))
                }, null, 544), [
                  [_vModelText, _ctx.form.analysisEndDate]
                ])
              ])
            ]),
            (_ctx.showErrors && _ctx.errors.dates)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("small", _hoisted_25, _toDisplayString(_ctx.errors.dates), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.advancedOpen = !_ctx.advancedOpen)),
              "aria-expanded": _ctx.advancedOpen.toString()
            }, _toDisplayString(_ctx.advancedOpen ? 'Hide Advanced Options' : 'Show Advanced Options'), 9, _hoisted_27),
            _withDirectives(_createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  (_ctx.filters.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, "No filters configured."))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: filter.id,
                      class: "row g-2 align-items-start mb-2"
                    }, [
                      _createElementVNode("div", _hoisted_33, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control shadow-none rounded-0 text-black",
                          placeholder: "Column name",
                          "onUpdate:modelValue": ($event: any) => ((filter.columnName) = $event)
                        }, null, 8, _hoisted_34), [
                          [_vModelText, filter.columnName]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control shadow-none rounded-0 text-black",
                          placeholder: "Comma separated values",
                          "onUpdate:modelValue": ($event: any) => ((filter.values) = $event)
                        }, null, 8, _hoisted_36), [
                          [_vModelText, filter.values]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-danger w-100",
                          onClick: ($event: any) => (_ctx.removeFilter(filter.id))
                        }, "Remove", 8, _hoisted_38)
                      ]),
                      (_ctx.showErrors && _ctx.errors.filters[index])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createElementVNode("small", _hoisted_40, _toDisplayString(_ctx.errors.filters[index]), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-primary",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.addFilter && _ctx.addFilter(...args)))
                  }, "Add Filter")
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "ensure-indices",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.ensureIndices) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.ensureIndices]
                    ]),
                    _hoisted_43
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control shadow-none rounded-0 text-black",
                      placeholder: "Optional override",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.workingTableOverride) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.form.workingTableOverride]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  (_ctx.containers.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, "No containers configured."))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.containers, (container, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: container.id,
                      class: "row g-2 align-items-start mb-2"
                    }, [
                      _createElementVNode("div", _hoisted_50, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control shadow-none rounded-0 text-black",
                          placeholder: "Name",
                          "onUpdate:modelValue": ($event: any) => ((container.name) = $event)
                        }, null, 8, _hoisted_51), [
                          [_vModelText, container.name]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          min: "0",
                          step: "0.01",
                          class: "form-control shadow-none rounded-0 text-black",
                          placeholder: "Width",
                          "onUpdate:modelValue": ($event: any) => ((container.width) = $event)
                        }, null, 8, _hoisted_53), [
                          [
                            _vModelText,
                            container.width,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          min: "0",
                          step: "0.01",
                          class: "form-control shadow-none rounded-0 text-black",
                          placeholder: "Height",
                          "onUpdate:modelValue": ($event: any) => ((container.height) = $event)
                        }, null, 8, _hoisted_55), [
                          [
                            _vModelText,
                            container.height,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            min: "0",
                            step: "0.01",
                            class: "form-control shadow-none rounded-0 text-black",
                            placeholder: "Depth",
                            "onUpdate:modelValue": ($event: any) => ((container.depth) = $event)
                          }, null, 8, _hoisted_58), [
                            [
                              _vModelText,
                              container.depth,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-outline-danger",
                            onClick: ($event: any) => (_ctx.removeContainer(container.id))
                          }, "Remove", 8, _hoisted_59)
                        ])
                      ]),
                      (_ctx.showErrors && _ctx.errors.containers[index])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                            _createElementVNode("small", _hoisted_61, _toDisplayString(_ctx.errors.containers[index]), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-primary",
                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.addContainer && _ctx.addContainer(...args)))
                  }, "Add Container")
                ])
              ])
            ], 512), [
              [_vShow, _ctx.advancedOpen]
            ])
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("button", {
              class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
              type: "submit",
              disabled: _ctx.isSubmitting || !_ctx.isFormValid
            }, [
              (!_ctx.isSubmitting)
                ? (_openBlock(), _createElementBlock("span", _hoisted_64, "Run Classification"))
                : (_openBlock(), _createElementBlock("span", _hoisted_65, [
                    _hoisted_66,
                    _createTextVNode(" Running... ")
                  ]))
            ], 8, _hoisted_63),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args))),
              disabled: _ctx.isSubmitting
            }, " Reset ", 8, _hoisted_67)
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_68, [
      _createElementVNode("div", _hoisted_69, [
        _createElementVNode("div", _hoisted_70, [
          _hoisted_71,
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("pre", _hoisted_73, _toDisplayString(_ctx.requestJsonPreview), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_74, [
        _createElementVNode("div", _hoisted_75, [
          _hoisted_76,
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("pre", _hoisted_78, _toDisplayString(_ctx.containersJsonPreview), 1)
          ])
        ])
      ])
    ]),
    (_ctx.result)
      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
          _hoisted_80,
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("div", _hoisted_83, [
                _hoisted_84,
                _createElementVNode("div", null, _toDisplayString(_ctx.result?.workingTable ?? 'Not provided'), 1)
              ]),
              _createElementVNode("div", _hoisted_85, [
                _hoisted_86,
                _createElementVNode("div", null, _toDisplayString(_ctx.windowLabel), 1)
              ]),
              _createElementVNode("div", _hoisted_87, [
                _hoisted_88,
                _createElementVNode("div", null, _toDisplayString(_ctx.result?.status ?? 'Unknown'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("div", _hoisted_90, [
                _hoisted_91,
                _createElementVNode("div", null, _toDisplayString(_ctx.headline.totalLines ?? '�'), 1)
              ]),
              _createElementVNode("div", _hoisted_92, [
                _hoisted_93,
                _createElementVNode("div", null, _toDisplayString(_ctx.headline.totalVolume_m3 ?? '�'), 1)
              ]),
              _createElementVNode("div", _hoisted_94, [
                _hoisted_95,
                _createElementVNode("div", null, _toDisplayString(_ctx.headline.uniqueSkus ?? '�'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("div", _hoisted_97, [
                _hoisted_98,
                _createElementVNode("pre", _hoisted_99, _toDisplayString(_ctx.formatCompactJson(_ctx.result?.summary?.byCategory)), 1)
              ]),
              _createElementVNode("div", _hoisted_100, [
                _hoisted_101,
                _createElementVNode("pre", _hoisted_102, _toDisplayString(_ctx.formatCompactJson(_ctx.result?.summary?.perSkuToteRanking)), 1)
              ]),
              _createElementVNode("div", _hoisted_103, [
                _hoisted_104,
                _createElementVNode("pre", _hoisted_105, _toDisplayString(_ctx.formatCompactJson(_ctx.result?.summary?.perSkuDailyBuckets)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_106, [
              _hoisted_107,
              (_ctx.materialisedTables.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_108, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.materialisedTables, (table) => {
                      return (_openBlock(), _createElementBlock("li", { key: table }, _toDisplayString(table), 1))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_109, "No materialised tables reported."))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}